// src/shack/pdfUtils.js — Renderiza la primera página de un PDF a imagen

let _pdfjsLib = null;

async function _cargarPdfjs() {
  if (_pdfjsLib) return _pdfjsLib;
  const lib = await import('pdfjs-dist');
  lib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
  ).href;
  _pdfjsLib = lib;
  return lib;
}

async function _renderizarPaginaPDF(blob) {
  const lib = await _cargarPdfjs();
  const arrayBuffer = await blob.arrayBuffer();
  const pdf = await lib.getDocument({ data: arrayBuffer }).promise;
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: 2 });
  const canvas = document.createElement('canvas');
  canvas.width  = viewport.width;
  canvas.height = viewport.height;
  await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
  return canvas;
}

export async function pdfBlobToImageBlobUrl(blob) {
  try {
    const canvas = await _renderizarPaginaPDF(blob);
    return await new Promise((resolve, reject) => {
      canvas.toBlob((b) => {
        canvas.width = 0;
        canvas.height = 0;
        if (!b) reject(new Error('canvas.toBlob devolvió null'));
        else resolve(URL.createObjectURL(b));
      }, 'image/jpeg', 0.92);
    });
  } catch (err) {
    console.warn('[pdfUtils] Error PDF→URL:', err.message);
    return null;
  }
}

export async function pdfBlobToImageBitmap(blob) {
  try {
    const canvas = await _renderizarPaginaPDF(blob);
    const bm = await createImageBitmap(canvas);
    canvas.width = 0;
    canvas.height = 0;
    return bm;
  } catch (err) {
    console.warn('[pdfUtils] Error PDF→ImageBitmap:', err.message);
    return null;
  }
}
